import React from 'react';

import RelatorioSecoesView from 'components/Relatorios/shared/Aprovacao/RelatorioSecoesView';

/**
 * Aba "Informe Intersemanal": delega às sub-abas/aprovação genéricas
 * (`RelatorioSecoesView`), configuradas em `helper/Relatorios/Aprovacao/config`.
 */
export default function IntersemanalView() {
  return <RelatorioSecoesView informe="intersemanal" />;
}
